var React = require('react');

function Abicon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.758 26.31A9.959 9.959 0 0 0 30 20c0-5.523-4.477-10-10-10s-10 4.477-10 10a9.96 9.96 0 0 0 2.28 6.358A10.048 10.048 0 0 1 15.05 24a5.994 5.994 0 0 0 4.99 2.668c2.08 0 3.914-1.06 4.99-2.668a10.048 10.048 0 0 1 2.73 2.31zM20 32c6.627 0 12-5.373 12-12S26.627 8 20 8 8 13.373 8 20s5.373 12 12 12zm5-14a5 5 0 1 1-10 0 5 5 0 0 1 10 0z","fill":"#fff"}));
}

Abicon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Abicon;

Abicon.default = Abicon;
